var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4476 18.4466L14.8538 14.8529M4.55176 10.5404C4.55176 8.95183 5.1828 7.42835 6.30607 6.30509C7.42933 5.18182 8.9528 4.55078 10.5413 4.55078C12.1299 4.55078 13.6534 5.18182 14.7766 6.30509C15.8999 7.42835 16.5309 8.95183 16.5309 10.5404C16.5309 12.1289 15.8999 13.6524 14.7766 14.7756C13.6534 15.8989 12.1299 16.5299 10.5413 16.5299C8.9528 16.5299 7.42933 15.8989 6.30607 14.7756C5.1828 13.6524 4.55176 12.1289 4.55176 10.5404Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.893623458d1820873387ab0c55fb1f53.svg";
export { ForwardRef as ReactComponent };